// Ukrainian locative case for city names ("в Тернополі", not the raw stored
// nominative "Тернопіль") - used wherever generated copy says "in {city}".
// Only the cities that exist today are mapped; an unknown/future city name
// falls back to itself undeclined (same limitation the K2-2985 ticket's own
// template examples had) rather than guessing a wrong declension.
const LOCATIVE_BY_NOMINATIVE = {
  'Тернопіль': 'Тернополі',
  'Луцьк': 'Луцьку'
}

export function declineCityLocative (name) {
  return LOCATIVE_BY_NOMINATIVE[name] || name
}
